export const MANUFACTURER_DELETE_OPEN_MODAL = "MANUFACTURER_DELETE_OPEN_MODAL";
export const MANUFACTURER_DELETE_REQUEST = "MANUFACTURER_DELETE_REQUEST";
export const MANUFACTURER_DELETE_RESULT = "MANUFACTURER_DELETE_RESULT";